import ValueDisplay from "./value-display";
import type { RenderProps } from "./types";

export default function phoneRenderer({
  value,
  fieldArr,
  isOldValue,
}: RenderProps) {
  // Prefer the explicit value prop; fall back to last filled_field value
  const resolved = value ?? fieldArr?.at(-1)?.value;
  const isObj =
    typeof resolved === "object" &&
    resolved !== null &&
    !Array.isArray(resolved);
  const phone = isObj
    ? (resolved as { number: string; calling_code?: string })
    : null;
  const number = phone?.number;
  const code = phone?.calling_code;

  if (!number && typeof resolved !== "string") {
    return <ValueDisplay isOldValue={isOldValue}>—</ValueDisplay>;
  }
  if (typeof resolved === "string") {
    return <ValueDisplay isOldValue={isOldValue}>{resolved}</ValueDisplay>;
  }
  const display = code ? `+(${code}) ${number}` : String(number);
  return <ValueDisplay isOldValue={isOldValue}>{display}</ValueDisplay>;
}
